module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    attrs: {
      "id": "lineDrawing"
    }
  }, [_c('svg', {
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "width": "800px",
      "height": "200px",
      "viewBox": "0 0 600 150",
      "enable-background": "new 0 0 600 150",
      "xml:space": "preserve"
    }
  }, [_c('g', {
    staticClass: "lines"
  }, [_c('path', {
    staticClass: "my-path",
    attrs: {
      "d": "M61.368,113.985c-0.096,0.702-0.82,1.161-1.32,1.161h-17.48c-0.702,0-1.072-0.663-1.004-1.161l3.839-28.407H27.458\n\t\t\t\tl-3.84,28.407c-0.095,0.702-0.82,1.161-1.319,1.161H4.818c-0.704,0-1.073-0.663-1.005-1.161l10.372-76.709\n\t\t\t\tc0.094-0.704,0.819-1.163,1.319-1.163h17.48c0.703,0,1.072,0.663,1.005,1.163l-3.853,28.498h17.945l3.853-28.498\n\t\t\t\tc0.095-0.704,0.821-1.163,1.32-1.163h17.479c0.705,0,1.073,0.663,1.006,1.163L61.368,113.985z M54.103,38.438l-3.854,28.499\n\t\t\t\tc-0.066,0.499-0.615,1.162-1.319,1.162H28.66c-0.499,0-1.1-0.458-1.005-1.162l3.853-28.499H16.352L6.295,112.824h15.156\n\t\t\t\tl3.84-28.406c0.068-0.499,0.616-1.163,1.32-1.163h20.271c0.499,0,1.1,0.459,1.004,1.163l-3.84,28.406h15.156l10.057-74.386H54.103z\n\t\t\t\t"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "my-path",
    attrs: {
      "d": "M92.789,113.985c-0.095,0.702-0.821,1.161-1.319,1.161h-17.48c-0.704,0-1.073-0.663-1.005-1.161l10.372-76.709\n\t\t\t\tc0.095-0.704,0.82-1.163,1.319-1.163h17.481c0.703,0,1.072,0.663,1.004,1.163L92.789,113.985z M85.522,38.438l-10.058,74.386\n\t\t\t\th15.156l10.057-74.386H85.522z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "my-path",
    attrs: {
      "d": "M109.025,111.695c-0.787,5.815-5.498,10.392-9.655,13.491c-0.322,0.241-0.744,0.198-0.956,0.002l-2.04-1.89\n\t\t\t\tc-0.211-0.196-0.425-0.669,0.11-1.122c0,0,2.524-2.178,3.761-5.246c-2.047-0.807-3.362-2.744-3.025-5.235\n\t\t\t\tc0.445-3.289,3.429-5.925,6.681-5.925C107.193,105.771,109.47,108.403,109.025,111.695z M98.72,111.695\n\t\t\t\tc-0.271,2.003,0.902,3.526,2.758,3.996c0.342,0.087,0.572,0.468,0.44,0.87c-0.947,2.888-2.814,5.007-3.888,6.085l1.064,0.986\n\t\t\t\tc3.832-2.951,7.772-7.075,8.43-11.938c0.333-2.468-1.358-4.425-3.827-4.425C101.28,107.271,99.054,109.224,98.72,111.695z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "my-path",
    attrs: {
      "d": "M145.646,113.985c-0.095,0.702-0.821,1.161-1.32,1.161h-17.48c-0.704,0-1.073-0.663-1.005-1.161l10.372-76.709\n\t\t\t\tc0.094-0.704,0.819-1.163,1.319-1.163h17.48c0.704,0,1.073,0.663,1.005,1.163L145.646,113.985z M138.38,38.438l-10.058,74.386\n\t\t\t\th15.156l10.056-74.386H138.38z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "my-path",
    attrs: {
      "d": "M172.296,36.116c0.384,0,0.744,0.298,0.64,0.803l-3.457,16.739c-0.085,0.413-0.505,0.697-0.842,0.697h-5.569\n\t\t\t\tc-0.415,0-0.676-0.361-0.654-0.697l1.07-16.739c0.024-0.383,0.35-0.803,0.856-0.803H172.296z M163.969,52.855h4.172l3.147-15.24\n\t\t\t\th-6.345L163.969,52.855z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "my-path",
    attrs: {
      "d": "M208.537,114.681c-0.48,0-0.87-0.319-0.979-0.725l-11.544-42.723l-6.026,42.758c-0.093,0.662-0.749,1.155-1.318,1.155\n\t\t\t\th-17.388c-0.703,0-1.072-0.663-1.005-1.161l10.372-76.709c0.095-0.704,0.821-1.163,1.32-1.163h24.732\n\t\t\t\tc0.481,0,0.877,0.317,0.983,0.744l10.415,41.439l21.446-41.435c0.232-0.451,0.725-0.748,1.186-0.748h24.826\n\t\t\t\tc0.704,0,1.073,0.663,1.006,1.163l-10.373,76.709c-0.095,0.702-0.82,1.161-1.319,1.161h-17.387c-0.662,0-1.082-0.582-1.006-1.157\n\t\t\t\tl5.621-42.78l-23.276,42.751c-0.241,0.444-0.741,0.72-1.173,0.72H208.537z M243.015,64.916c0.713-1.311,2.178,0.437,2.178,0.437\n\t\t\t\tl-6.236,47.472h15.067l10.058-74.386h-22.865L218.698,81.95c-1.089,2.103-2.17,0.003-2.17,0.003L205.59,38.438h-22.774\n\t\t\t\tl-10.058,74.386h15.07l6.691-47.475c0.199-1.414,2.297-0.43,2.297-0.43l12.818,47.438h7.549L243.015,64.916z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "my-path",
    attrs: {
      "id": "letter-a",
      "d": "M360.663,113.549c0,0,0.595,1.598-1.293,1.598h-18.782c-0.481,0-0.88-0.312-0.984-0.753l-3.511-14.589h-27.577\n\t\t\t\tl-7.271,14.577c-0.227,0.455-0.713,0.765-1.195,0.765h-18.782c0,0-1.802,0.151-0.863-1.596l41.242-76.709\n\t\t\t\tc0.239-0.446,0.737-0.728,1.176-0.728h16.18c0.48,0,0.87,0.322,0.979,0.727L360.663,113.549z M323.293,38.438l-39.992,74.386\n\t\t\t\th16.248l7.27-14.578c0.229-0.454,0.714-0.766,1.198-0.766h29.195c0.469,0,0.877,0.302,0.985,0.753l3.51,14.591h16.253\n\t\t\t\tl-20.057-74.386H323.293z M333.021,84.463h-17.292c-1.856,0-0.874-1.58-0.874-1.58l11.571-22.313\n\t\t\t\tc1.091-2.102,2.169-0.007,2.169-0.007l5.723,22.314C334.764,84.616,333.021,84.463,333.021,84.463z M327.032,64.203l-9.301,17.935\n\t\t\t\th13.901L327.032,64.203z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "my-path",
    attrs: {
      "d": "M379.933,37.276c0,0,0.438-2.366,2.024-0.898l40.955,37.961l5.186-37.068c0.095-0.663,0.747-1.157,1.319-1.157h17.481\n\t\t\t\tc0.702,0,1.07,0.663,1.005,1.163l-10.372,76.709c0,0-0.43,2.361-2.021,0.897l-41.144-37.869l-4.999,36.972\n\t\t\t\tc-0.096,0.702-0.821,1.161-1.321,1.161h-17.479c-0.703,0-1.072-0.663-1.006-1.161L379.933,37.276z M387.2,112.824l5.173-38.264\n\t\t\t\tc0.312-2.308,2.021-0.898,2.021-0.898l41.145,37.87l9.883-73.094h-15.16l-5.367,38.361c-0.324,2.308-2.021,0.891-2.021,0.891\n\t\t\t\tl-40.947-37.951l-9.882,73.085H387.2z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "my-path",
    attrs: {
      "d": "M482.501,36.113c21.613,0,37.52,16.492,34.413,39.47c-3.118,23.068-23.39,39.563-45.099,39.563h-22.316\n\t\t\t\tc-0.703,0-1.071-0.663-1.006-1.161l10.372-76.709c0.096-0.704,0.821-1.163,1.32-1.163H482.501z M450.975,112.824h21.155\n\t\t\t\tc20.503,0,39.52-15.492,42.459-37.241c2.927-21.652-11.991-37.145-32.403-37.145h-21.15L450.975,112.824z M469.093,99.527\n\t\t\t\tc-0.499,0-1.101-0.46-1.005-1.164l6.146-45.467c0.068-0.499,0.617-1.162,1.318-1.162c19.456,0,24.534,10.065,22.659,23.943\n\t\t\t\tC496.334,89.557,488.541,99.527,469.093,99.527z M476.4,54.071l-5.83,43.119c17.445-0.389,23.609-8.885,25.317-21.512\n\t\t\t\tC497.604,62.993,493.622,54.459,476.4,54.071z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "my-path",
    attrs: {
      "d": "M591.781,36.113c0,0,2.119-0.133,0.768,1.748l-33.596,46.777l-3.968,29.348c-0.095,0.702-0.821,1.161-1.319,1.161h-19.992\n\t\t\t\tc-0.702,0-1.072-0.663-1.004-1.161l3.969-29.349l-20.855-46.777c0,0-0.936-1.746,1.241-1.746h20.549\n\t\t\t\tc0.432,0,0.798,0.276,0.933,0.593l12.076,28.312l19.553-28.307c0.264-0.378,0.729-0.598,1.097-0.598H591.781z M551.204,67.965\n\t\t\t\tc-1.341,1.944-2.029,0.005-2.029,0.005l-12.596-29.532h-17.85l20.197,45.301c0.077,0.175,0.104,0.381,0.078,0.585l-3.853,28.5\n\t\t\t\th17.665l3.854-28.5c0.027-0.203,0.108-0.409,0.236-0.585l32.535-45.301h-17.842L551.204,67.965z"
    }
  })])])]), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    attrs: {
      "id": "navvy"
    }
  }, [_c('ul', [_c('li', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://github.com/andthomas"
    }
  }, [_c('i', {
    staticClass: "fab fa-github"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.linkedin.com/in/andy-t-brown/"
    }
  }, [_c('i', {
    staticClass: "fab fa-linkedin-in"
  })])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "menu"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("(There's not much here, come see by "), _c('a', {
    attrs: {
      "href": "https://blog.andybrown.dev/"
    }
  }, [_vm._v("blog")]), _vm._v(")")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-358e88eb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/Landing.vue
// module id = 48
// module chunks = 0